import { Injectable } from '@angular/core';
import { GenericAkitaHTTPService, HttpOptions } from '../../service/generic-akita-http.service';
import { CrowdFlowSensorSite } from '../../model/crowd-flow-sensor-site';
import { HttpClient } from '@angular/common/http';
import { NetworkService } from '../../service/network.service';

@Injectable({
  providedIn: 'root'
})
export class AkitaHTTPCrowdFlowSensorSiteService extends GenericAkitaHTTPService<CrowdFlowSensorSite> {
  constructor(http: HttpClient, networkService: NetworkService) {
    const options: HttpOptions = {
      params: {
        type: 'CrowdFlowSensorSite',
        options: 'keyValues',
        limit: '50'
      }
    };
    super(http, networkService, '/v2/entities/', 'CrowdFlowSensorSite', options);
  }
}


